import React from 'react';
import styled from 'styled-components';

const Footer = styled.div`
  margin-top: 1rem;

  a {
    color: black;
    text-decoration: underline;
  }
`;

export const FooterReCaptcha = () => {
  return (
    <Footer>
      <small>
        reCAPTCHA e a<a href="https://policies.google.com/privacy"> Política de Privacidade</a> e os
        <a href="https://policies.google.com/terms"> Termos de Serviço</a> do Google são aplicáveis.
      </small>
    </Footer>
  );
};
